import React, { useState, useEffect, useRef } from "react";
import { Form, Button } from "react-bootstrap";
import SimpleReactValidator from "simple-react-validator";
import OnSubmitErrorMessage from "../../../Common/Errors/OnSubmitErrorMessage";
import * as _ from "../../../../constants/Constants";
import { getUserRolePermission } from "../../../../utils/rolePermissionAccess";
import * as RolePermissionConstants from "../../../../constants/RolePermissionConstants";
import ErrorContainer from "../../../Common/Errors/ErrorContainer";
import { extractVendorStatus } from "../../../VendorOnboarding/OnboardingContainer";
import { useDispatch, shallowEqual, useSelector } from "react-redux";
import { updateCommonInfo } from "../../../../redux/commonSlice";
import {
  vendorInfoFields,
  vendorPlatformFields,
  ownedVendorFields,
} from "./FormFields";
import Cookie from "js-cookie";
import "./style.css";
import {
  calculateTargetLiveDate,
  renderFormFields,
  extractMergeCenterValues,
  disableIntegrationInstructions,
  extractHierarchyDetails,
  getTodaysDateAndTime,
  extractformValues,
  getPiplineUsers,
  getSortedArrayBasedOnDept,
} from "./helpers";
import {
  modifyVDFValues,
  checkOnBoardingStatus,
} from "../../../../utils/utils";
import {
  httpPostUpdateVendorProfile,
  httpGetThreeNotesByProfileId,
  httpGetVendorStatusDetails,
} from "../../../../service/httpClient";
import {
  updateServiceData,
  updateVendorProfileDetails,
} from "../../../../redux/serviceSlice";
import * as Constants from "../../../../constants/Constants";

const PreBoardingVendorProfile = ({
  getVDFValue,
  integrationStartDate,
  onboardingStatus,
  vendorDetails,
  profileTypeDetails,
  vendorStatus,
  roleName,
  getUpdatedVendorData,
}) => {
  const store = useSelector(
    ({ service, common }) => ({
      vendorConnectionPlatform: common.vendorConnectionPlatform || "",
      merchandiseType:
        service.vendorProfile?.vendorDetail?.merchandiseType || "",
    }),
    shallowEqual
  );

  const dispatch = useDispatch();
  const simpleValidator = useRef(
    new SimpleReactValidator({
      validators: {
        VDF: {
          message: _.VP_CHANGE_VDF_ERR_MSG,
          rule: (val, params, validator) => {
            if (modifyVDFValues(getVDFValue())) {
              return val === modifyVDFValues(getVDFValue());
            }
            return true;
          },
          required: true,
        },
      },
    })
  );

  const [
    {
      formValues,
      resetValues,
      submitSuccess,
      errMsg,
      valuesChanged,
      isPrimaryVendor,
      isProfileType,
      disableSaveButton,
    },
    setFormValues,
  ] = useState({
    formValues: {
      vendorDetails: extractformValues(),
      profileTypeDetails: [],
      mergeCenterDefaultValue: [],
      reset: false,
      errors: {},
      formDisabled:
        roleName !== _.EXTERNAL_VENDOR_GENERIC &&
        roleName !== _.EXTERNAL_GENERIC_ADMIN,
      isMerchApproved: false,
      isDVNSetupApproved: false,
      liveVendor: false,
    },
    resetValues: {},
    submitSuccess: false,
    errMsg: null,
    valuesChanged: false,
    isPrimaryVendor: false,
    isProfileType: false,
    disableSaveButton: false,
  });

  const [isSaving, setIsSaving] = useState(false);

  const [isOwnedVendor, setIsOwnedVendor] = useState(false);

  const extractVendorInfo = () => {
    let dataObj = {};
    const {
      id,
      duns,
      isPrimaryVendor,
      plOwnerShip,
      status,
      merchandiseType,
    } = vendorDetails;

    const hierarchyDetails = vendorDetails?.hierarchyDetails || [];

    const initialValueKeys = [
      ...Object.keys(formValues.vendorDetails),
      "integrationStartDate",
    ];

    let unSortedHierarchyDetails = [...hierarchyDetails];
    let sortedHierarchyDetails =
      unSortedHierarchyDetails.length > 0
        ? getSortedArrayBasedOnDept(unSortedHierarchyDetails)
        : [];

    const hierarchyInfo = Array.isArray(sortedHierarchyDetails)
      ? extractHierarchyDetails(sortedHierarchyDetails)
      : {};
    const profinfo = Array.isArray(profileTypeDetails)
      ? profileTypeDetails
      : {};

    initialValueKeys.forEach((key) => {
      if (key !== "integrationStartDate" && vendorDetails[key]) {
        dataObj = {
          ...dataObj,
          [key]: vendorDetails[key],
        };
      } else {
        dataObj = {
          ...dataObj,
          [key]: vendorDetails[key] ? vendorDetails[key] : null,
          ["splitIntegrationStartDate"]: vendorDetails[key]
            ? vendorDetails[key].split("T")[0]
            : null,
        };
      }
    });

    dataObj = {
      ...dataObj,
      ...hierarchyInfo,
      ...profinfo,
      id,
      duns,
      plOwnerShip,
      merchandiseType,
    };

    return {
      vendorDetails: {
        ...formValues.vendorDetails,
        ...dataObj,
      },
      profileTypeDetails,
      hierarchyDetails,
      userEmail: JSON.parse(localStorage.getItem("roles")).emailId,
      duns,
      isPrimaryVendor,
      isMerchApproved: status === "Approved",
    };
  };
  const extractStatus = () => {
    let statusInfo = {};
    vendorStatus.forEach(({ statusName, vendorStatus }) => {
      const isApproved = vendorStatus?.lastStatusUpdatedValue === "Approved";
      if (statusName === "setupDvn") {
        statusInfo = {
          ...statusInfo,
          isDVNSetupApproved: isApproved,
          registerationDate: isApproved
            ? vendorStatus?.lastStatusUpdatedDate
            : getTodaysDateAndTime(),
        };
      }
    });
    return statusInfo;
  };
  const loadInitialData = async (isSaving = false) => {
    let vendorInfo = extractVendorInfo();
    let pipelineUsers = [];
    if (
      formValues?.pipelineUsers === undefined ||
      formValues?.pipelineUsers?.length === 0
    ) {
      pipelineUsers = await getPiplineUsers();
    } else {
      pipelineUsers = formValues?.pipelineUsers;
    }
    let { isDVNSetupApproved, registerationDate } = extractStatus();

    let { vendorDetails } = vendorInfo;
    vendorDetails.vendorConnectionPlatform = modifyVDFValues(
      vendorDetails.vendorConnectionPlatform
    );
    let plOwnerShipName = null;

    pipelineUsers &&
      pipelineUsers.forEach(({ userName, emailId }) => {
        if (vendorDetails.plOwnerShip === emailId) {
          plOwnerShipName = userName;
        }
      });

    let ownedVendor = false;
    if (
      vendorDetails.merchandiseType === _.VOB_MERCHANDISE_TYPE_OWNED_VENDOR &&
      vendorDetails.vendorConnectionPlatform === _.STATUS_PLATFORMTYPE_DIRECTEDI
    ) {
      ownedVendor = true;
    }

    if (!vendorDetails.goLiveTarget && vendorDetails.integrationStartDate) {
      vendorDetails.goLiveTarget = calculateTargetLiveDate(
        vendorDetails.integrationStartDate,
        vendorDetails.vendorConnectionPlatform,
        ownedVendor
      );
    }

    vendorInfo = {
      ...vendorInfo,
      isDVNSetupApproved,
      registerationDate,
      mergeCenterDefaultValue: extractMergeCenterValues(
        vendorDetails.mergeCenter
      ),
      vendorDetails: {
        ...vendorInfo.vendorDetails,
        plOwnerShipName: plOwnerShipName,
        mergeCenter:
          vendorDetails.mergeCenter?.length > 0
            ? vendorDetails.mergeCenter
            : null,
      },
    };

    setFormValues((state) => {
      const saveState = {
        formValues: {
          ...state.formValues,
          pipelineUsers,
          ...vendorInfo,
          onLoadIntegInstrucVal:
            vendorInfo.vendorDetails?.integrationInstructions,
        },
        valuesChanged: false,
        isPrimaryVendor: vendorInfo.isPrimaryVendor,
        isProfileType: vendorInfo.profileTypeDetails.length > 1 ? false : true,
        submitSuccess: isSaving,
      };
      return {
        ...saveState,
        resetValues: saveState,
      };
    });
  };
  useEffect(() => {
    loadInitialData();
  }, []);

  useEffect(() => {
    if (onboardingStatus === Constants.VENDOR_SUBMISSION) {
      loadInitialData();
    }
  }, [onboardingStatus]);

  useEffect(() => {
    if (isSaving) {
      loadInitialData(isSaving);
      isSaving && setIsSaving(false);
    }
  }, [isSaving]);

  useEffect(() => {
    setFormValues((state) => {
      state.formValues.vendorDetails.integrationStartDate = integrationStartDate;
      state.formValues.vendorDetails.splitIntegrationStartDate = integrationStartDate
        ? integrationStartDate.split("T")[0]
        : null;
      state.formValues.liveVendor =
        onboardingStatus !== "" &&
        checkOnBoardingStatus(onboardingStatus, [_.LIVE]);
      return state;
    });
  }, [
    integrationStartDate,
    onboardingStatus,
    formValues.onLoadIntegInstrucVal,
  ]);

  useEffect(() => {
    onboardingStatus &&
      disableIntegrationInstructions(
        formValues.onLoadIntegInstrucVal ||
          formValues.vendorDetails?.integrationInstructions,
        checkOnBoardingStatus(onboardingStatus, [
          _.VENDOR_STATUS_PROGRESS_INPROCESS,
          _.HOLD_STATE,
          _.VP_MA_SB_LIVE_ONBOARD_COMPL,
        ])
      );
  }, [
    integrationStartDate,
    onboardingStatus,
    formValues.onLoadIntegInstrucVal,
  ]);

  useEffect(() => {
    if (
      store.merchandiseType === _.VOB_MERCHANDISE_TYPE_OWNED_VENDOR &&
      store.vendorConnectionPlatform === _.STATUS_PLATFORMTYPE_DIRECTEDI
    ) {
      setIsOwnedVendor(true);
    } else {
      setIsOwnedVendor(false);
    }
  }, [store.merchandiseType, store.vendorConnectionPlatform]);

  useEffect(() => {
    if (
      store.merchandiseType === _.VOB_MERCHANDISE_TYPE_OWNED_VENDOR &&
      formValues?.vendorDetails?.vendorConnectionPlatform ===
        _.STATUS_PLATFORMTYPE_DIRECTEDI
    ) {
      setIsOwnedVendor(true);
    } else {
      setIsOwnedVendor(false);
    }
  }, [formValues.vendorDetails.vendorConnectionPlatform]);

  const refreshDataInStore = async (newVendorStatus) => {
    const profileId = vendorDetails?.id.toString();
    const notes = await httpGetThreeNotesByProfileId(profileId);
    const vendorStatus = await httpGetVendorStatusDetails(profileId);

    const { mutatedVendorStatus } = extractVendorStatus(
      newVendorStatus ? newVendorStatus : vendorDetails.status,
      vendorStatus.data
    );

    //update vendorStatus in service data
    dispatch(
      updateServiceData({
        notes: notes.data,
        vendorStatus: vendorStatus.data,
      })
    );
    //update vendorstatus in common slice
    dispatch(
      updateCommonInfo({
        boardingStatuses: mutatedVendorStatus,
        vendorConnectionPlatform:
          formValues.vendorDetails.vendorConnectionPlatform, //update vendorConnectionPlatform in common slice
      })
    );
  };

  const handleSubmit = () => {
    setFormValues((state) => ({
      ...state,
      disableSaveButton: true,
      submitSuccess: false,
      errMsg: null,
    }));

    formValues.vendorDetails.integrationStartDate = integrationStartDate;

    let vendorProfileDto = {
      ...formValues.vendorDetails,
      hierarchyDetails: [...formValues.hierarchyDetails],
    };
    let submitData = {
      vendorProfileDto,
      userEmail: formValues.userEmail,
      updatedByFullName: Cookie.get("userName") ? Cookie.get("userName") : "",
    };
    httpPostUpdateVendorProfile({ ...submitData })
      .then((res) => {
        getUpdatedVendorData(res?.data?.vendorProfileDto?.id)
          .then(() => {
            setIsSaving(true);
          })
          .catch((error) => {
            console.log(error);
          });
      })
      .catch((error) => {
        console.log(error);
        setFormValues((state) => ({
          ...state,
          submitSuccess: false,
          errMsg:
            error.response && error.response.data
              ? error.response.data.message
              : _.VP_SAVE_ERR_MSG,
          disableSaveButton: false,
        }));
      });
  };

  const handleFormReset = () => {
    let oldFormValues = resetValues.formValues;
    oldFormValues.reset = true;
    setFormValues((state) => ({
      ...state,
      formValues: oldFormValues,
    }));
  };

  const userPermissionOnDataEdit = getUserRolePermission(
    RolePermissionConstants.VENDORPLATFORM_PREBOARDING_VENDORPROFILE,
    RolePermissionConstants.VMP_SAVE
  );

  const userPermissionOnPageAccess = getUserRolePermission(
    RolePermissionConstants.VENDORPLATFORM_PREBOARDING_VENDORPROFILE,
    RolePermissionConstants.ALL
  );

  return (
    <>
      {userPermissionOnPageAccess === RolePermissionConstants.NONE ? (
        <div>
          <ErrorContainer
            errorMsg={
              RolePermissionConstants.VMP_VENDORPROFILE_PAGE_ACCESS_ERROR_MSG
            }
            errorStatus={true}
            errorStyle="errorMessage"
          />
        </div>
      ) : (
        <div>
          {simpleValidator.current.purgeFields()}
          {submitSuccess && (
            <OnSubmitErrorMessage
              type="success"
              message={_.VP_SAVE_SUCCESS_MSG}
            />
          )}
          {submitSuccess === false && (
            <OnSubmitErrorMessage type="error" message={errMsg} />
          )}
          <Form>
            {isOwnedVendor && (
              <Form.Row>
                {renderFormFields(
                  ownedVendorFields,
                  formValues,
                  setFormValues,
                  simpleValidator,
                  isPrimaryVendor,
                  isProfileType,
                  onboardingStatus
                )}
              </Form.Row>
            )}
            {!isOwnedVendor && (
              <>
                <Form.Row>
                  {renderFormFields(
                    vendorInfoFields,
                    formValues,
                    setFormValues,
                    simpleValidator,
                    isPrimaryVendor,
                    isProfileType,
                    onboardingStatus
                  )}
                </Form.Row>
                <Form.Row>
                  {formValues.vendorDetails.vendorConnectionPlatform ===
                    "directEdiRDS" &&
                    renderFormFields(
                      vendorPlatformFields,
                      formValues,
                      setFormValues,
                      simpleValidator,
                      isPrimaryVendor,
                      isProfileType
                    )}
                </Form.Row>
              </>
            )}
          </Form>
          <div>
            <Button
              id="updateAddrBtn"
              size="md"
              onClick={() => handleSubmit()}
              className="button-primary-md"
              style={btnStyles}
              disabled={
                !valuesChanged ||
                errMsg ||
                !simpleValidator.current.allValid() ||
                JSON.stringify(formValues.errors) !== "{}" ||
                userPermissionOnDataEdit !== RolePermissionConstants.EDIT ||
                disableSaveButton
              }
            >
              Save
            </Button>
            <Button
              id="updateAddrBtn"
              size="md"
              onClick={() => handleFormReset()}
              className="button-later-md"
              style={btnStyles}
              disabled={
                userPermissionOnDataEdit !== RolePermissionConstants.EDIT
              }
            >
              Cancel
            </Button>
          </div>
        </div>
      )}
    </>
  );
};

const btnStyles = {
  margin: "0 10px 30px 10px",
  float: "right",
};

export default PreBoardingVendorProfile;
